import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Track } from '../../services/trackService';

interface TrackMetadataFormProps {
  value: Partial<Track>;
  onChange: (value: Partial<Track>) => void;
}

const TrackMetadataForm: React.FC<TrackMetadataFormProps> = ({ value, onChange }) => {
  const { t } = useTranslation();
  const [artistOptions, setArtistOptions] = useState<string[]>([]);

  useEffect(() => {
    setArtistOptions(JSON.parse(localStorage.getItem('cassette_artists') || '[]'));
  }, []);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    const { name, value: val, type } = e.target;
    if (type === 'checkbox' && e.target instanceof HTMLInputElement) {
      onChange({ ...value, [name]: e.target.checked });
    } else {
      onChange({ ...value, [name]: val });
    }
  };

  return (
    <div className="flex flex-col gap-3">
      <div>
        <label className="block text-base font-medium" style={{ color: 'var(--color-text)' }}>
          {t('track.name')} <span className="text-red-500">*</span>
        </label>
        <input
          name="name"
          value={value.name || ''}
          onChange={handleChange}
          className="mt-1 block w-full border-b focus:outline-none focus:border-[var(--brand-from)] px-1 text-base font-normal"
          style={{ borderColor: 'var(--color-border)', backgroundColor: 'var(--color-surface)' }}
          placeholder={t('track.namePlaceholder')}
          required
        />
      </div>
      <div>
        <label className="block text-base font-medium" style={{ color: 'var(--color-text)' }}>
          {t('track.artist')} <span className="text-red-500">*</span>
        </label>
        <input
          name="artist"
          value={value.artist || ''}
          onChange={handleChange}
          className="mt-1 block w-full border-b focus:outline-none focus:border-[var(--brand-from)] px-1 text-base font-normal"
          style={{ borderColor: 'var(--color-border)', backgroundColor: 'var(--color-surface)' }}
          placeholder={t('track.artistPlaceholder')}
          required
          list="artist-list"
        />
        <datalist id="artist-list">
          {artistOptions.map(option => (
            <option value={option} key={option} />
          ))}
        </datalist>
      </div>
      {/* Note about additional fields */}
      <div className="mt-4 p-3 rounded-lg border" style={{ backgroundColor: 'var(--color-hover)', borderColor: 'var(--color-border)' }}>
        <p className="text-sm" style={{ color: 'var(--color-muted)' }}>
          {t('track.additionalFieldsNote')}
        </p>
      </div>
    </div>
  );
};

export default TrackMetadataForm; 